<!--
 Created by Xuz on 2019/01/22.
 xuz[at]live.cn
 流程下一步菜单
-->
<template>
    <span>
        <span v-show="loading"><img :src="$_c + 'img/loading-bar.gif'"/></span>
        <span v-show="!loading">
            <a-button v-if="xwfState.processEnd && xwfState.actIns != null && (xwfState.actIns.state === 'U' || xwfState.actIns.state === 'A')" class="xwf-menu" @click="onEndTask"><a-icon type="check" /> 我已阅</a-button>
            <a-button v-if="xwfState.withdraw" class="xwf-menu" @click="onWithdraw"><a-icon type="rollback" /> 撤回</a-button>
<!--            <a-button v-if="xwfState.withdrawHuiQian" class="xwf-menu" @click="onWithdrawHuiQian"><a-icon type="rollback" /> 撤回会签</a-button>-->
<!--            <a-button v-if="xwfState.withdrawChuanYue" class="xwf-menu" @click="onWithdrawChuanYue"><a-icon type="rollback" /> 撤回传阅</a-button>-->
<!--            <a-button v-if="xwfState.withdrawBingFa" class="xwf-menu" @click="onWithdrawBingFa"><a-icon type="rollback" /> 撤回并发</a-button>-->
<!--            <a-button v-if="xwfState.withdrawTransfer" class="xwf-menu" @click="onWithdrawTransfer"><a-icon type="rollback" /> 撤回转办</a-button>-->
            <a-button v-if="xwfState.hasNext" class="xwf-menu" type="primary" @click="onProcessNext"><a-icon type="right-square" /> 下一步</a-button>
<!--            <a-button v-if="xwfState.hasNext" class="xwf-menu" @click="onTransfer"><a-icon type="select" /> 转办</a-button>-->
<!--            <a-button v-if="xwfState.wfadmin" class="xwf-menu" @click="onManageTransfer"><a-icon type="select" /> 流程管理</a-button>-->
<!--            <a-button v-if="xwfState.wfadmin" class="xwf-menu" @click="onManageSetRoute"><a-icon type="select" /> 流程调度</a-button>-->
<!--            <a-button v-if="xwfState.hasNext" class="xwf-menu" @click="onChuanYue"><a-icon type="retweet" /> 传阅</a-button>-->
<!--            <a-button v-if="xwfState.simpleHandRound" class="xwf-menu" @click="onSimpleHandRounded"><a-icon type="check" /> 我已阅</a-button>-->
<!--            <a-button v-if="xwfState.simpleHandRound" class="xwf-menu" @click="onChuanYue"><a-icon type="retweet" /> 继续传阅</a-button>-->
            <a-button v-if="xwfState.hasProcessInstance" class="xwf-menu" @click="onViewHistory"><a-icon type="file-done" /> 流程跟踪</a-button>
<!--            <a-button v-if="false" @click="onXwfCaseAttachMgr"><a-icon type="paper-clip" />附件</a-button>--> 
            <workflow-next ref="wfNext" :xwfState="xwfState" :visible="modalVisible.next" @cancel="modalVisible.next = false" />
            <workflow-transfer ref="wfTransfer" :xwfState="xwfState" :visible="modalVisible.transfer" @cancel="modalVisible.transfer = false" />
            <workflow-chuan-yue ref="wfChuanYue" :visible="modalVisible.chuanYue" @cancel="modalVisible.chuanYue = false" />
            <workflow-history ref="wfHistory" :visible="modalVisible.history" @cancel="modalVisible.history = false" />
            <workflow-withdraw ref="wfWithdraw" :visible="modalVisible.withdraw" @cancel="modalVisible.withdraw = false"/>
            <WorkflowWithdrawHQCY ref="wfWithdrawHQCY" :visible="modalVisible.withdrawHQCY" @cancel="modalVisible.withdrawHQCY = false"/>
            <ProcessInstanceManage :visible="modalVisible.workflowDiaodu" @cancel="modalVisible.workflowDiaodu = false" ref="processInsMgr"/>
          <workflow-case-attach-mgr ref="wfCaseAttachMgr" :xwfState="xwfState" :visible="modalVisible.wfCaseAttachMgr" modelTitle="附件管理" @success="onXwfCaseAttachMgrSuccess" @cancel="onXwfCaseAttachMgrCancel"/>
        </span>
    </span>
</template>

<script>
import WorkflowNext from '@/components/workflow/WorkflowNext'
import WorkflowHistory from '@/components/workflow/WorkflowHistory'
import WorkflowTransfer from '@/components/workflow/WorkflowTransfer'
import WorkflowChuanYue from '@/components/workflow/WorkflowChuanYue'
import WorkflowWithdraw from '@/components/workflow/withdraw/WorkflowWithdraw'
import WorkflowWithdrawHQCY from '@/components/workflow/withdraw/WorkflowWithdrawHQCY'
import ProcessInstanceManage from '@/views/workflow/manage/ProcessInstanceManage'
import WorkflowCaseAttachMgr from '@/components/workflow/WorkflowCaseAttachMgr'
import { WorkflowEvent } from './WorkflowEvent'
import qs from 'qs'

export default {
  name: 'WorkflowMenu',
  components: {
    WorkflowNext,
    WorkflowTransfer,
    WorkflowChuanYue,
    WorkflowHistory,
    WorkflowWithdraw,
    WorkflowWithdrawHQCY,
    ProcessInstanceManage,
    WorkflowCaseAttachMgr
  },
  props: {
    value: {
      type: String,
      default: null
    },
    onBeforeNext: {
      type: Function,
      required: false,
      default: null
    }
  },
  mounted () {
    WorkflowEvent.$on('OnCommentSet', this.onCommentSet)
    WorkflowEvent.$on('PostCommentSave', this.onPostCommentSave)
    WorkflowEvent.$on('PostXwfNext', () => {
      this.$router.push({ path: '/workflow/task' })
    })
    WorkflowEvent.$on('PostXwfWithdraw', () => {
      this.onReloadPage()
    })
    WorkflowEvent.$on('PostXwfTransfer', () => {
      this.onReloadPage()
    })
    WorkflowEvent.$on('PostXwfChuanYue', () => {
      this.onReloadPage()
    })
    WorkflowEvent.$on('PostXwfWithdrawTransfer', () => {
      this.onReloadPage()
    })
    WorkflowEvent.$on('PostXwfSimpleHandRound', () => {
      this.onReloadPage()
    })
    WorkflowEvent.$on('PostXwfEndTask', () => {
      this.onReloadPage()
    })
  },
  created () {
    this.onFetchData()
  },
  beforeDestroy () {
    WorkflowEvent.$off('PostCommentSave', this.onPostCommentSave)
  },
  data () {
    return {
      loading: true,
      wfJsParams: null,
      xwfState: {},
      modalVisible: {
        next: false,
        transfer: false,
        chuanYue: false,
        history: false,
        withdraw: false,
        withdrawHQCY: false,
        workflowDiaodu:false,
        wfCaseAttachMgr: false
      },
      comment: null
    }
  },
  methods: {
    onXwfCaseAttachMgr () {
      this.modalVisible.wfCaseAttachMgr = true
      this.$refs.wfCaseAttachMgr.preData(this.xwfState)
    },
    onXwfCaseAttachMgrSuccess () {
      this.modalVisible.wfCaseAttachMgr = false
    },
    onXwfCaseAttachMgrCancel () {
      this.modalVisible.wfCaseAttachMgr = false
    },
    onReloadPage () {
      this.$router.go(0)
      // this.onFetchData()
    },
    onFetchData () {
      const that = this
      that.loading = true
      that.$http.get('/api/1/workflow/xwf_state.json?id=' + this.$route.query.id).then(function (resp) {
        if (resp.code === 200) {
          that.loading = false
          that.xwfState = resp.result
          that.wfJsParams = 'caseTypeId=' + that.xwfState.caseTypeId + '&id=' + that.xwfState.caseId +
                            '&procInsId=' + that.xwfState.procInsId + '&actInsId=' + that.xwfState.actInsId
          that.$emit('onLoadXWFState', that.xwfState)
        }
      })
    },
    onProcessNext () {
      if (this.$props.onBeforeNext !== null) {
        if (!this.$props.onBeforeNext()) {
          return
        }
      }
      let canNext = false
      // 检查是否有输入意见
      if (this.xwfState.hasSignOption) {
        // 有意见输入框，没有填意见
        if (this.comment == null || !this.comment.content) {
          if (this.xwfState.mustComment) {
            // 必须填写意见
            this.$warning({
              title: '请先填写意见再执行下一步操作'
            })
          } else {
            // 提示填写意见
            const that = this
            this.$confirm({
              title: '您还没填写意见，是否确认下一步操作？',
              onOk () {
                WorkflowEvent.$emit('PreXwfNext')
                that.openNext()
              }
            })
          }
        } else {
          canNext = true
        }
      } else {
        canNext = true
      }
      if (canNext) {
        // 没有意见框，直接下一步
        WorkflowEvent.$emit('PreXwfNext')
        this.openNext()
      }
    },
    onCommentSet (comment) {
      // 用户提交了意见后
      this.comment = comment
    },
    onPostCommentSave () {
      if (this.xwfState.hasNext) {
        this.onProcessNext()
      }
    },
    openNext () {
      this.modalVisible.next = true
      this.$refs.wfNext.update(this.xwfState)
    },
    onTransfer () {
      this.modalVisible.transfer = true
      this.$refs.wfTransfer.preTransfer(this.xwfState, 1)
    },
    onManageTransfer () {
      this.modalVisible.transfer = true
      this.$refs.wfTransfer.preTransfer(this.xwfState, 2)
    },
    onManageSetRoute () {//流程调度
      this.modalVisible.workflowDiaodu = true
      this.$refs.processInsMgr.preManage(this.xwfState.procInsId)
    },
    onChuanYue () {
      this.modalVisible.chuanYue = true
      this.$refs.wfChuanYue.preChuanYue(this.xwfState)
    },
    onViewHistory () {
      this.modalVisible.history = true
      this.$refs.wfHistory.onLoadData(this.xwfState.procInsId)
    },
    onWithdraw () {
      const that = this
      this.$confirm({
        title: '您确定要执行撤回操作吗？',
        onOk () {
          that.modalVisible.withdraw = true
          that.$refs.wfWithdraw.update(that.xwfState)
        }
      })
    },
    onWithdrawHuiQian () {
      const that = this
      this.$confirm({
        title: '您确定要执行会签撤回操作吗？',
        onOk () {
          that.modalVisible.withdrawHQCY = true
          that.$refs.wfWithdrawHQCY.update(that.xwfState, 'H')
        }
      })
    },
    onWithdrawChuanYue () {
      const that = this
      this.$confirm({
        title: '您确定要执行传阅撤回操作吗？',
        onOk () {
          that.modalVisible.withdrawHQCY = true
          that.$refs.wfWithdrawHQCY.update(that.xwfState, 'Y')
        }
      })
    },
    onWithdrawBingFa () {
      const that = this
      this.$confirm({
        title: '您确定要执行并发撤回操作吗？',
        onOk () {
          that.modalVisible.withdrawHQCY = true
          that.$refs.wfWithdrawHQCY.update(that.xwfState, 'C')
        }
      })
    },
    onWithdrawTransfer () {
      const that = this
      this.$confirm({
        title: '您确定要执行转办撤回操作吗？',
        onOk () {
          let data = {}
          data.actInsId = that.xwfState.actInsId
          that.$http.post('/api/1/workflow/withdraw_transfer_action.json', qs.stringify(data)).then(function (resp) {
            if (resp.code === 200) {
              that.$message.success('操作已完成')
            }
            WorkflowEvent.$emit('PostXwfWithdrawTransfer')
          })
        }
      })
    },
    onSimpleHandRounded () {
      const that = this
      let data = {}
      data.actInsId = that.xwfState.actInsId
      that.$http.post('/api/1/workflow/simple_handround_action.json', qs.stringify(data)).then(function (resp) {
        that.$message.success('操作已完成')
        WorkflowEvent.$emit('PostXwfSimpleHandRound')
      })
    },
    onEndTask () {
      // 如果流程已办结，那些未办件的件还可以让用户填个意见，最后结束掉
      const that = this
      let data = {}
      data.actInsId = that.xwfState.actInsId
      that.$http.post('/api/1/workflow/end_task_action.json', qs.stringify(data)).then(function (resp) {
        that.$message.success('操作已完成')
        WorkflowEvent.$emit('PostXwfEndTask')
      })
    }
  }
}
</script>

<style scoped>
    .xwf-menu {
        margin-right: 4px;
    }

    .xwf-menu:last-child {
        margin-right: 12px;
    }

    .ant-modal-header {
        padding: 16px 24px;
        border-radius: 4px 4px 0 0;
        background: #fff;
        color: rgba(0,0,0,.65);
        border-bottom: 1px solid #e8e8e8;
        background: #2f7fe3;
    }
</style>
